import {Utils} from "../utils";
import {MenuCategory} from "./Menu";

export class OrderDetails {
  constructor() {
    this.id = null;
    this.uuid = null;
    this.name = '';
    this.description = '';
    this.address = '';
    this.phone = '';

    this.contactName = '';

    this.dateStart = '';
    this.timeStart = '';
    this.dateEnd = '';
    this.timeEnd = '';
    this.event = '';

    this.deliveryDate = '';
    this.deliveryTime = '';

    this.timezone = null;
    this.location = '';
    this.state = '';
    this.city = '';
    this.zipcode = '';

    this.snapchat = '';
    this.twitter = '';
    this.facebook = '';
    this.instagram = '';
    this.linkedin = '';
    this.price = 0;
    this.total = 0;
    this.sub_total = 0;
    this.tax = 0;
    this.orderedMenu = null;
  }

  map(details) {
    this.id = details.id;
    this.uuid = details.uuid;
    this.name = details.name;
    this.description = details.description;
    this.address = details.address;
    this.phone = details.phone;

    this.contactName = details.primary_contact_name;

    this.dateStart = details.start != null ? Utils.parseDate(new Date(details.start)) : null;
    this.timeStart = details.start != null ? Utils.parseTime(new Date(details.start)) : null;
    this.dateEnd = details.end != null ? Utils.parseDate(new Date(details.end)) : null;
    this.timeEnd = details.end != null ? Utils.parseTime(new Date(details.end)) : null;
    this.event = details.event;

    this.deliveryDate = Utils.parseDate(new Date(details.delivery_date));
    this.deliveryTime = Utils.parseTime(new Date(details.delivery_date));

    this.timezone = details.timezone;
    this.location = details.delivery_location;
    this.state = details.state;
    this.city = details.city;
    this.zipcode = details.zipcode;

    this.snapchat = details.snapchat_link;
    this.twitter = details.twitter_link;
    this.facebook = details.facebook_link;
    this.instagram = details.instagram_link;
    this.linkedin = details.linkedin_link;

    this.price = details.price;
    this.total = details.total;
    this.sub_total = details.sub_total;
    this.tax = details.tax;

    if (details.ordered_menu) {
      this.orderedMenu = details.ordered_menu.map(category => new MenuCategory().map(category))
    }

    return this;
  }

  update(details) {
    if (details.id) this.id = details.id;
    if (details.uuid) this.uuid = details.uuid;
    if (details.name) this.name = details.name;
    if (details.description) this.description = details.description;
    if (details.address) this.address = details.address;
    if (details.phone) this.phone = details.phone;

    if (details.contactName) this.contactName = details.contactName;

    if (details.dateStart) this.dateStart = details.dateStart;
    if (details.timeStart) this.timeStart = details.timeStart;
    if (details.dateEnd) this.dateEnd = details.dateEnd;
    if (details.timeEnd) this.timeEnd = details.timeEnd;
    if (details.event) this.event = details.event;

    if (details.deliveryDate) this.deliveryDate = details.deliveryDate;
    if (details.deliveryTime) this.deliveryTime = details.deliveryTime;

    if (details.timezone) this.timezone = details.timezone;
    if (details.location) this.location = details.location;
    if (details.state) this.state = details.state;
    if (details.city) this.city = details.city;
    if (details.zipcode) this.zipcode = details.zipcode;

    if (details.snapchat) this.snapchat = details.snapchat;
    if (details.twitter) this.twitter = details.twitter;
    if (details.facebook) this.facebook = details.facebook;
    if (details.instagram) this.instagram = details.instagram;
    if (details.linkedin) this.linkedin = details.linkedin;

    if (details.price != null) this.price = details.price;
    if (details.total != null) this.total = details.total;
    if (details.sub_total != null) this.sub_total = details.sub_total;
    if (details.tax != null) this.tax = details.tax;

    if (details.orderedMenu) {
      this.orderedMenu = [...details.orderedMenu]
    }

    return this;
  }

  updateZipCode(zipCode) {
    if (zipCode) this.zipcode = zipCode;

    return this;
  }

  get details() {
    return {
      id: this.id,
      uuid: this.uuid,
      name: this.name,
      description: this.description,
      address: this.address,
      phone: this.phone,

      contactName: this.contactName,

      dateStart: this.dateStart,
      timeStart: this.timeStart,
      dateEnd: this.dateEnd,
      timeEnd: this.timeEnd,
      event: this.event,

      deliveryDate: this.deliveryDate,
      deliveryTime: this.deliveryTime,

      timezone: this.timezone,
      location: this.location,
      state: this.state,
      city: this.city,
      zipcode: this.zipcode,

      snapchat: this.snapchat,
      twitter: this.twitter,
      facebook: this.facebook,
      instagram: this.instagram,
      linkedin: this.linkedin,
      price: this.price,
      orderedMenu: this.orderedMenu,
    }
  }
}
